import React from 'react';
import { connect } from 'react-redux';
import { toggleSelected } from '../../actions/actions';
import classNames from 'classnames';
import './style.scss';

class Thumbnail extends React.Component {
  getThumbClassNames() {
    return classNames (
      'thumb',
      {'selected': this.props.selected}
    );
  }

  toggleSelected() {
    this.props.toggleSelected(this.props.id);
  }

  render() {
    return (
      <div className={this.getThumbClassNames()} onClick={this.toggleSelected.bind(this)}>
        <div className="image">
          <img src={"/images/" + this.props.image} />
        </div>
        <div className="title">{this.props.title}</div>
        <div className="select">
          <div className="select-label">select</div>
          <div className="select-icon">
            <i className="icon-checkmark"/>
          </div>
        </div>
      </div>
    );
  }
}

Thumbnail.propTypes = {
  toggleSelected: React.PropTypes.func.isRequired,
  id: React.PropTypes.number,
  title: React.PropTypes.string,
  image: React.PropTypes.string,
  selected: React.PropTypes.bool
};

export default connect(null, {toggleSelected})(Thumbnail);



/** WEBPACK FOOTER **
 ** ./src/components/thumbnail/index.js
 **/